import { getFontAwesomeClassName } from "@/other/utils/utils.jsx";
import { cn } from "@/modern/utils";
import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from "@/modern/components/ui/select";
interface IconSelectorProps {
  value: number | null;
  onChange: (value: number | null) => void;
  items: any[]; // eslint-disable-line @typescript-eslint/no-explicit-any
  disabled?: boolean;
  className?: string;
  color?: string | null;
}

export const IconSelector = ({ value, onChange, items, disabled, className, color }: IconSelectorProps) => {
  const [selectedIcon, setSelectedIcon] = useState<string | null>(null);

  useEffect(() => {
    if (value) {
      const item = items.find((i) => i.id === value);
      if (item) {
        setSelectedIcon(getFontAwesomeClassName(item.tagValue));
      }
    } else {
      setSelectedIcon(null);
    }
  }, [value, items]);

  return (
    <Select
      value={value?.toString() || ""}
      onValueChange={(val) => onChange(val ? parseInt(val) : null)}
      disabled={disabled}
    >
      <SelectTrigger className={cn("h-12", className)}>
        {selectedIcon ? (
          <div className="flex items-center gap-2">
            <i className={cn("fa icon-selector-icon", selectedIcon)} style={{ color: color || "inherit" }} />
          </div>
        ) : (
          <span className="text-muted-foreground">Select an icon</span>
        )}
      </SelectTrigger>
      <SelectContent position="popper" sideOffset={5} className={"z-[--swivu-bryntum-z-index]"}>
        {items.map((item) => {
          const iconClass = getFontAwesomeClassName(item.tagValue);
          return (
            <SelectItem key={item.id} value={item.id.toString()}>
              <div className="flex items-center gap-2">
                <i className={cn("fa", iconClass)} />
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
